<template lang="pug">
.page 
    z-table(:route="`tradeAccount/${id}/user`" 
        :editAble="false"
        :searchAble="true"
        :columns="columns")
</template>

<script>
import MyIcon from '../../components/MyIcon';

export default {
    props: ['id'],
    data() {
        return {
            visible: false,
            columns: [
                {
                    title: '用户名',
                    dataIndex: 'name',
                    addAble: true,
                },
                {
                    title: '权限',
                    dataIndex: 'perm',
                    addAble: true,
                    type: 'Enum',
                    enum: [
                        'readOnly',
                        'trade',
                        'admin',
                    ]
                }
            ],
            
        };
    },
    mounted() {
        
    },
    methods: {
        handleClick() {
            this.visible = true;
        }
    },
    computed: {
    },
    components: {
        MyIcon
    }
}
</script>